/* 🤖 this file was generated by script */
export const wsolidiconGlobe01 = {
  name: 'globe_01',
  data: `<svg viewBox="0 0 24 24"><path fill="currentColor" d="M19.34 1.66a1 1 0 1 0-1.42 1.42A10.5 10.5 0 0 1 3.82 18.6l1.42-1.42a8.5 8.5 0 1 0-1.41-1.41l-1.62 1.6-.27.29q-.17.18-.3.53A1.49 1.49 0 0 0 2 19.66q.15.14.28.26l.02.01A12.5 12.5 0 0 0 19.34 1.66"/></svg>`,
  iconStyle: 'solid',
};
